import { render, staticRenderFns } from "./TrainingModuleImageDialog.vue?vue&type=template&id=755a8d95&scoped=true&"
import script from "./TrainingModuleImageDialog.vue?vue&type=script&lang=js&"
export * from "./TrainingModuleImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./TrainingModuleImageDialog.vue?vue&type=style&index=0&id=755a8d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a8d95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VCard,VCol,VDialog,VIcon,VImg,VRow,VSpacer})
